import { FETCH_SHOPS_FOR_FILTER } from '../constants';
import { SET_BRAND } from '../../../../../auth/constants';

const isFetched = (state = false, action) => {
  switch (action.type) {
    case FETCH_SHOPS_FOR_FILTER:
      return true;
    case SET_BRAND:
      return false;
    default:
      return state;
  }
};

export default isFetched;
